import React, {useEffect,useState} from 'react';

let available=[{value:'deposit',label:'Deposit'},{value:'click',label:'Click'}];
export const goalLabel=(value) => available.find((goal) => goal.value===value)?.label || value || '—';
export default function GoalOptions({disableClick=false}) {
  const [goals,setGoals]=useState(available);
  useEffect(() => {
    const controller=new AbortController();
    fetch('/api/v1/campaigns/goals',{signal:controller.signal,headers:{Accept:'application/json'}})
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {if (data?.goals && !controller.signal.aborted) {available=data.goals;setGoals(data.goals);}})
      .catch(() => {});
    return () => controller.abort();
  },[]);
  return <>{goals.map((goal) => <option key={goal.value} value={goal.value} disabled={disableClick && goal.value==='click'}>{goal.label}</option>)}</>;
}
